import React from "react";
import "./style.scss";
import logo from "../../../assets/icons/logoEquityEdge.svg";
import dp from "../../../assets/icons/profilePicture.svg";
import image from "../../../assets/icons/signInBoxDecor.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { Autoplay, EffectCoverflow, Mousewheel } from "swiper/modules";
import SwiperCoverflow from "./SwiperCoverflow";
import CryptoBrandIcon from "../../../assets/newIcons/cryptoLogo.svg";


function AuthFrame() {
  const ReviewData = [
    {
      profilePic: dp,
      heading: "Brooklyn Simmons",
      country: "USA",
      information: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ",
    },
    {
      profilePic: dp,
      heading: " MSimmons",
      country: "USA",
      information: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ",
    },
    {
      profilePic: dp,
      heading: " Simmons",
      country: "USA",
      information: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ",
    },
  ];
  return (
    <div className="authFrameSection_container">
      <div className="authFrameSection_wrapper">
        {/* <h3 style={{color: "black"}}>Left Section</h3> */}
        <div className="upperSection">
          <div className="companyLogo sign-in">
            <img
              src={logo}
              alt="logo"
            />
            {/* <span style={{fontSize:"40px",fontWeight:"900"}}>/</span>
            <img
              src={CryptoBrandIcon}
              alt="CryptoBrandIcon"
            /> */}
          </div>
          <div className="shortIntro">
            <h3>Your Trading Journey Starts Here</h3>
            <p>Access your dashboard, manage your trading accounts, and track your performance in real-time. Stay ahead of the market with the tools and resources designed for success.</p>
          </div>
        </div>
        {/* <div className="lowerSect">
          {ReviewData.map((item, index) => (
            <div
              className={`sliderSect sliderSect-${index}`}
              key={index}
            >
              <div className="titleSect">
                <div className="profilePic">
                  <img
                    src={item.profilePic}
                    alt=""
                  />
                </div>
                <div className="Title">
                  <div className="heading">
                    <h5>{item.heading}</h5>
                  </div>
                  <div className="countryName">
                    <p>{item.country}</p>
                  </div>
                </div>
              </div>
              <div className="decorImg">
                <img
                  src={image}
                  alt=""
                />
              </div>
              <div className="infoSect">
                <p>{item.information}</p>
              </div>
            </div>
          ))}
        </div>  */}
        {/* <div className="lowerSect swiper_coverflow">
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            loop={true} // Enables looping of slides
            slidesPerView={3}
            autoplay={{
              delay: 30000, // Adjust delay as needed
              disableOnInteraction: false, // Ensures autoplay continues after user interaction
            }}
            // breakpoints={{
            //   320: {
            //     slidesPerView: 1,
            //     coverflowEffect: {stretch: 0, depth: 100},
            //   },
            //   768: {
            //     slidesPerView: 2,
            //     coverflowEffect: {stretch: -20, depth: 150},
            //   },
            //   1024: {
            //     slidesPerView: 3,
            //     coverflowEffect: {stretch: -40, depth: 250},
            //   },
            // }}
            coverflowEffect={{
              rotate: 0,
              stretch: -40,
              depth: 250,
              modifier: 3.5,
              slideShadows: false,
            }}
            modules={[EffectCoverflow, Autoplay, Mousewheel]}
          >
            {ReviewData.map((item, index) => (
              <SwiperSlide>
                <div
                  className="sliderSect"
                  key={index}
                >
                  <div className="titleSect">
                    <div className="profilePic">
                      <img
                        src={item.profilePic}
                        alt=""
                      />
                    </div>
                    <div className="Title">
                      <div className="heading">
                        <h5>{item.heading}</h5>
                      </div>
                      <div className="countryName">
                        <p>{item.country}</p>
                      </div>
                    </div>
                  </div>
                  <div className="decorImg">
                    <img
                      src={image}
                      alt=""
                    />
                  </div>
                  <div className="infoSect">
                    <p>{item.information}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div> */}

        <div className="swiper_coverflow">
          <SwiperCoverflow />
        </div>
      </div>
    </div>
  );
}

export default AuthFrame;
